





















import { Component, Vue, Prop } from 'vue-property-decorator';
import Snackbar from '@/models/Snackbar';

@Component
export default class AppNotificationBar extends Vue {
  public status = false;

  get isDark(): boolean {
    return this.$store.getters.isDark;
  }

  get snackbar(): Snackbar {
    return this.$store.getters.snackbar;
  }

  get snackbarObj() {
    if (!this.snackbar) {
      return {};
    }

    this.status = true;

    return {
      status: this.snackbar.status || true,
      text: this.snackbar.text,
      time: this.snackbar.time || 4000,
      icon: this.snackbar.icon || '',
      color: this.snackbar.color || 'success',
      position: this.snackbar.position || 'top'
    };
  }
}
